// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureTabGroup {
    static getAttributeTypeMap() {
        return QpsignatureTabGroup.attributeTypeMap;
    }
}
QpsignatureTabGroup.discriminator = undefined;
QpsignatureTabGroup.additionalProperties = false;
QpsignatureTabGroup.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "tabs",
        "baseName": "tabs",
        "type": "Array<QpsignatureTab>"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
];
//# sourceMappingURL=qpsignatureTabGroup.js.map